
export default {
  namespaced: true,
  state: {
    openedLoaded: false,
  },
  actions: {
    /**
     * @description 
     * @param {Object} context
     */
    isLoaded ({ state }) {
      if (state.openedLoaded) return Promise.resolve()
      return new Promise(resolve => {
        const timer = setInterval(() => {
          if (state.openedLoaded) resolve(clearInterval(timer))
        }, 10)
      })
    },
    /**
     * @class opened
     * @description 从持久化数据用户信息
     * @param {Object} context
     */
    async openedLoad ({ state, commit, dispatch }) {
      await dispatch('tccc/db/get', {
        dbName: 'sys',
        path: 'user.info',
        defaultValue: {},
        user: true
      }, { root: true })

      await dispatch('tccc/db/get', {
        dbName: 'sys',
        path: 'client.info',
        defaultValue: {},
        user: true
      }, { root: true })

      state.openedLoaded = true
      
    },
  }
}
